import React from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import theme from './theme/theme';
import Navbar from './components/Navbar';
import Hero from './sections/Hero';
import Features from './sections/Features';
import HowItWorks from './sections/HowItWorks';
import DashboardPreview from './sections/DashboardPreview';
import Security from './sections/Security';
import CTASection from './sections/CTASection';
import Footer from './sections/Footer';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ overflow: 'hidden' }}>
        <Navbar />
        <Hero />
        <Features />
        <HowItWorks />
        <DashboardPreview />
        <Security />
        <CTASection />
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default App;
